import { useQuery } from "@tanstack/react-query";

import axios, { AxiosError } from "axios";

const useGetUserProfile = (
  username?: string,
  additionally?: string | boolean
) => {
  const { data, isLoading, error } = useQuery({
    queryKey: ["userProfile", username, additionally],
    queryFn: () => getData(username, additionally),
    enabled: !!username && !!additionally,
    retry: (failureCount, error) => {
      if (
        error instanceof AxiosError && 
        (error.response?.status === 403 || error.response?.status === 404)
      ) {
        return false; // Не ретраить при 404 и 403
      }
      return failureCount < 5; // Ретраить только 5 раз для других ошибок
    },
  });

  return { data, isLoading, error };
};

const getData = async (username?: string, additionally?: string | boolean) => {
  const response = await axios.get(
    `/user-profile/${username}${
      additionally !== "profile" ? "/" + additionally : ""
    }`
  );
  return response.data;
};

export default useGetUserProfile;
